import { forwardRef, HtmlHTMLAttributes, memo } from "react";
import classnames from "classnames";
import { FeedItemBase, FeedItemBaseProps, FeedItemBaseSize } from "../FeedItemBase";

import styles from "./style.module.scss";

export type ActivityFeedEventType = Omit<FeedItemBaseProps, "size" | "connector">

export type ActivityFeedsProps = HtmlHTMLAttributes<HTMLDivElement> & {
  size?: FeedItemBaseSize
  events?: ActivityFeedEventType[]
  divider?: "line" | "connector" | "none"
};

export const ActivityFeeds = memo(
  forwardRef<HTMLDivElement, ActivityFeedsProps>((
    {
      size = "md",
      events,
      divider = "connector",
      ...props
    },
    ref,
  ) => {
    return (
      <div
        {...props}
        className={classnames(
          props.className,
          styles.root,
          styles[divider as keyof typeof styles]
        )}
        ref={ref}
      >
        {events?.map((item: FeedItemBaseProps, index: number) => (
          <FeedItemBase
            {...item}
            key={item.id ?? index}
            className={classnames(styles.feedItemBase, item.className)}
            connector={divider === "connector" && events?.length - 1 !== index}
            size={size}
          />
        ))}
      </div>
    );
  }));
